import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { User } from '../types/user';

type GetCurrentUserResponse = {
    user: User;
};

async function getCurrentUser(): Promise<GetCurrentUserResponse | null> {
    try {
        const { data } = await api.get(`/profile`);
        return data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response?.status === 404) {
                return null;
            }
            throw error;
        }
        throw error;
    }
}

export function useCurrentUser(id?: string): UseQueryResult<GetCurrentUserResponse, AxiosError> {
    return useQuery(['current-user'], () => getCurrentUser(), { keepPreviousData: false, enabled: Boolean(id) });
}
